import styled from '@mui/system/styled'
import { Column } from 'src/components/Layout/Styled'

export const StyledFormWrapper = styled(Column)(({ theme }) => ({
  position: 'relative',
  padding: '18px',
  alignItems: 'center',
  img: { padding: '5.5px 0', marginBottom: theme.spacing(0.5) },
}))
